import { NavLink } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";
import { faClipboardList, faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function GestaoProdutosSubnav() {
    return (
        <div className="menu-submenu menu-submenu-classic menu-submenu-left">
            <ul className="menu-subnav">
                <li className="menu-item">
                    <NavLink
                        to={ACESSOS.GERAL.TELAS.GESTAO_PRODUTOS.DS_PATH}
                        className="menu-link"
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faHome} />
                        </span>
                        <span className="menu-text">Produtos</span>
                    </NavLink>
                </li>
                <li className="menu-item">
                    <NavLink
                        to={ACESSOS.GERAL.TELAS.FORMULARIOS_PRODUTOS.DS_PATH}
                        className="menu-link"
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faClipboardList} />
                        </span>
                        <span className="menu-text">Formulários</span>
                    </NavLink>
                </li>
            </ul>
        </div>
    );
}
